export default __webpack_public_path__ + "static/media/Anubis_2.9b98bffc.png";